import type { ChartDatum, LineChartSeries } from '@lmc/design-system'
import dayjs from 'dayjs'

/** A named series with one value per period (week or month), counted from a start date. */
export type PeriodSeries = {
  data: number[]
  name: string
}

export const PERIOD_TIME_KEY = 'time'

/**
 * Index-based period series as LineChart rows: point `i` of every series sits at `start` plus
 * `i` units. Series are keyed `s0`, `s1` … because their names are translated text.
 */
export const periodSeriesToRows = (
  periodSeries: PeriodSeries[],
  start: dayjs.ConfigType,
  unit: 'month' | 'week'
): { rows: ChartDatum[]; series: LineChartSeries[] } => {
  const origin = dayjs(start)
  const length = Math.max(0, ...periodSeries.map(({ data }) => data.length))

  return {
    rows: Array.from({ length }, (_, index) => ({
      [PERIOD_TIME_KEY]: origin.add(index, unit).valueOf(),
      ...Object.fromEntries(
        periodSeries.map(({ data }, seriesIndex) => [
          `s${seriesIndex}`,
          data[index] ?? null
        ])
      )
    })),
    series: periodSeries.map(({ name }, seriesIndex) => ({
      key: `s${seriesIndex}`,
      label: name
    }))
  }
}
